export default __webpack_public_path__ + "static/commercial-ampm--mobile@1x-20f396c928b0b97c865733ae4f463d8c.jpg";